"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PaymentSessionExpiredPopupWidget = void 0;
var React = require("react");
var core_1 = require("@athena-portal/core");
var components_1 = require("@athena-portal/components");
var PaymentSessionExpiredPopupWidget = exports.PaymentSessionExpiredPopupWidget = /** @class */ (function (_super) {
    __extends(PaymentSessionExpiredPopupWidget, _super);
    function PaymentSessionExpiredPopupWidget(props) {
        var _this = _super.call(this, props) || this;
        _this.state = {
            showSessionWarning: false
        };
        _this.mountTokenChecks = _this.mountTokenChecks.bind(_this);
        _this.unmountTokenChecks = _this.unmountTokenChecks.bind(_this);
        _this.loginButtonClick = _this.loginButtonClick.bind(_this);
        return _this;
    }
    PaymentSessionExpiredPopupWidget.prototype.componentDidMount = function () {
        window.addEventListener("load", function () {
            if (!location.search.includes("?auth")) {
                history.pushState({}, "", location.href + "?auth");
            }
        });
        this.mountTokenChecks();
    };
    PaymentSessionExpiredPopupWidget.prototype.componentWillUnmount = function () {
        this.unmountTokenChecks();
    };
    PaymentSessionExpiredPopupWidget.prototype.render = function () {
        return (React.createElement(components_1.Modal, { isOpen: this.state.showSessionWarning, backdrop: "static" },
            React.createElement(components_1.ModalHeader, null, "Just to let you know"),
            React.createElement(components_1.ModalBody, null,
                React.createElement("p", null, "Your session expired due to inactivity"),
                React.createElement("p", null, "Please Log in to continue")),
            React.createElement(components_1.ModalFooter, null,
                React.createElement(components_1.Button, { color: "btn btn-primary btn-next btn-wide", onClick: this.loginButtonClick }, "Log in"))));
    };
    PaymentSessionExpiredPopupWidget.prototype.mountTokenChecks = function () {
        var _this = this;
        var interval = 1000;
        this.interval = window.setInterval(function () {
            // Add hoc access to application guard property
            var expiresAtTimestamp = _this.applicationGuard['keycloak'].refreshTokenParsed.exp * 1000;
            var nowTimestamp = new Date().getTime() + interval; // Compensate interval value
            if (nowTimestamp >= expiresAtTimestamp) {
                _this.setState({ showSessionWarning: true });
                _this.unmountTokenChecks();
            }
        }, interval);
    };
    PaymentSessionExpiredPopupWidget.prototype.unmountTokenChecks = function () {
        window.clearInterval(this.interval);
    };
    PaymentSessionExpiredPopupWidget.prototype.loginButtonClick = function () {
        this.applicationGuard.logout();
    };
    __decorate([
        (0, core_1.lazyInject)(core_1.TypeDefs.ApplicationGuard),
        (0, core_1.optional)(),
        __metadata("design:type", Object)
    ], PaymentSessionExpiredPopupWidget.prototype, "applicationGuard", void 0);
    return PaymentSessionExpiredPopupWidget;
}(React.Component));
//# sourceMappingURL=PaymentSessionExpiredPopupWidget.js.map


//////////////////
// WEBPACK FOOTER
// ../falcon-plugins/plugin-falcon-journey/dist/widgets/payments/PaymentSessionExpiredPopupWidget.js
// module id = 3460
// module chunks = 0